import { createApp } from 'vue'
import App from './App.vue'
import store from './vuex/store'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import router from './router'

const vuetify = createVuetify({
  components,
  directives
})
createApp(App).use(router).use(vuetify)
.use(store).mount('#app')
